var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeospatial(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33583 4.53836V10.2142C1.33583 11.3225 2.12333 11.7775 3.08 11.2292L4.45083 10.4475C4.74833 10.2784 5.24416 10.2609 5.55333 10.4184L8.61583 11.9525C8.925 12.1042 9.42083 12.0925 9.71833 11.9234L12.2442 10.4767C12.565 10.29 12.8333 9.83503 12.8333 9.46169V3.78586C12.8333 2.67753 12.0458 2.22253 11.0892 2.77086L9.71833 3.55253C9.42083 3.72169 8.925 3.73919 8.61583 3.58169L5.55333 2.05336C5.24416 1.90169 4.74833 1.91336 4.45083 2.08253L1.925 3.52919C1.59833 3.71586 1.33583 4.17086 1.33583 4.53836Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99333 2.33331V9.91665",
    stroke: "#8E8E8E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17583 3.86169V11.6667",
    stroke: "#8E8E8E",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeospatial);
export default __webpack_public_path__ + "static/media/Geospatial.23ddf4b6aac0b59165f9c0b305d33049.svg";
export { ForwardRef as ReactComponent };